export default "__VITE_ASSET__D44d2ezG__"